import React from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../context/AuthContext';
import './TrialBanner.css';

export default function TrialBanner() {
  const { t } = useTranslation();
  const { user, isTrialExpired, daysRemaining } = useAuth();
  
  if (!user || !user.trial_end_date) return null;

  const isWarning = daysRemaining <= 5 && daysRemaining >= 0;

  if (isTrialExpired) {
    return (
      <div className="trial-banner expired">
        <div className="trial-banner-content">
          <span className="trial-icon">⚠️</span>
          <span className="trial-text">
            {t('trialBanner.expiredPrefix')} <strong>{t('trialBanner.renewSubscription')}</strong> {t('trialBanner.expiredSuffix')}
          </span>
        </div>
      </div>
    );
  }

  return (
    <div className={`trial-banner ${isWarning ? 'warning' : 'active'}`}>
      <div className="trial-banner-content">
        <span className="trial-icon">{isWarning ? '⏳' : '📅'}</span>
        <span className="trial-text">
          {t('trialBanner.endsIn')} <strong>{t('trialBanner.dayCount', { count: daysRemaining })}</strong>
        </span>
      </div>
    </div>
  );
}
